import { MultipleChoiceQuestionUIConfig } from './MultipleChoiceQuestionUIConfig';
import {
	AnswerOptionsField,
	EvaluationCategoryID,
	MedicationQuestionId,
	PreWorkQuestionId,
} from './Constants';
export interface CategoryStepUIConfig {
	id: number;
	title: string;
	functionaryTitle?: string;
	subTitle: string;
	questions: MultipleChoiceQuestionUIConfig[];
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: Array<string>;
		mandatoryQuestionsToAsk: MultipleChoiceQuestionUIConfig[];
	};
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: Array<string>;
		mandatoryQuestionsToAsk: MultipleChoiceQuestionUIConfig[];
	};
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: Array<string>;
		mandatoryQuestionsToAsk: MultipleChoiceQuestionUIConfig[];
	};
	questionsToAskInOtherReferenceInterview: Array<string>;
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: Array<string>;
		mandatoryQuestionsToAsk: MultipleChoiceQuestionUIConfig[];
	};
}

export const InspirationAndWillingnessUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.INSPIRATION_AND_WILLINGNESS,
	title: 'inspirationAndWillingness',
	subTitle: 'primaryQualificationForATrainer',
	questions: [
		{
			questionId: 1,
			categoryId: 1,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmWillingToVolunteerTime',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 2,
			categoryId: 1,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iUnderstandAndWantToContributeToVision',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 3,
			categoryId: 1,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmWillingToVolunteerAndServe',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 150,
			categoryId: 1,
			questionNo: 4,
			questionText: 'whyDoYouWantToVolunteerWithHFN',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 222,
				categoryId: 1,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'howLongHaveYouSeenThisPersonAsAbhyasi',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 201,
				categoryId: 1,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'thankYouWouldYouLikeToServeAsAPreceptor',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
			{
				questionId: 202,
				categoryId: 1,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'haveYouVolunteered',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const PracticeUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.PRACTICE,
	title: 'practice',
	subTitle: 'trainerNeedsToBeIntensePractitioner',
	questions: [
		{
			questionId: 4,
			categoryId: 2,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'howLongHaveIBeenAPractitioner',
			answerOptions: [
				{ optionId: 1, optionText: 'zeroToSixMonths' },
				{ optionId: 2, optionText: 'sixMonthsToOneYear' },
				{ optionId: 3, optionText: 'oneToThreeYears' },
				{ optionId: 4, optionText: 'moreThanThreeYears' },
			],
			displayAnswerOptionsVertically: true,
			required: true,
			hideComments: true,
		},
		{
			questionId: 5,
			categoryId: 2,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'myDailyPractiseIsRegular',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 6,
			categoryId: 2,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iTakeSittings',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 7,
			categoryId: 2,
			questionNo: 4,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmConvincedAboutTheRoleAndSupport',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 151,
			categoryId: 2,
			questionNo: 5,
			questionText: 'whatChangesDoYouSee',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 225,
				categoryId: 2,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'doYouKnowIfCandidateDoesTheirSadhanaRegularly',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 208,
				categoryId: 2,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'howHasThePracticeImpactedYou',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
			{
				questionId: 209,
				categoryId: 2,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'doYouFollowAnyOtherPractice',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const AvailabilityAfterProgramUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.AVAILABILITY_AFTER_PROGRAM,
	title: 'availabilityAfterProgram',
	subTitle: 'exploreIfWillingnessTranslatesToAction',
	questions: [
		{
			questionId: 14,
			categoryId: 4,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iCommitOfAtleastFiveHoursEveryWeek',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 15,
			categoryId: 4,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iUndertakeThatIBalanceMyProfessionalAndSpiritualLives',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 153,
			categoryId: 4,
			questionNo: 3,
			questionText: 'whatTypeOfVolunteerHaveYouBeen',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 231,
				categoryId: 4,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'doYouThinkCandidateWillHaveTimeForPreceptorWork',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 213,
				categoryId: 4,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'availableForAtLeastThreeToFiveHrs',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 240,
				categoryId: 4,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'doYouAgreeApplicantHaveTime',
				required: true,
				commentsText: 'recordFamilyMemberResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const BasicEligibilityUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.BASIC_ELIGIBILITY,
	title: 'essentials',
	subTitle: 'thisIsMandatoryCriteria',
	questions: [
		{
			questionId: 23,
			categoryId: 7,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'heartfulnessStartsAtMyHome',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 24,
			categoryId: 7,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'notInvolvedInDomesticAbuseOrViolence',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 25,
			categoryId: 7,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'notInvolvedInSexualAbuse',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 26,
			categoryId: 7,
			questionNo: 4,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'notPartOfNegativeImpact',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 27,
			categoryId: 7,
			questionNo: 5,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'noLegalCasesOrComplaints',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 28,
			categoryId: 7,
			questionNo: 6,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'neverSeekFinancialTransactions',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 29,
			categoryId: 7,
			questionNo: 7,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'myFinancialDealingsAreHonest',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 31,
			categoryId: 7,
			questionNo: 8,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iConsumeAlcoholOccassionally',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 32,
			categoryId: 7,
			questionNo: 9,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iConsumeNonVegFoodOccassionally',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 33,
			categoryId: 7,
			questionNo: 10,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmOfReasonablySoundPhysicalHealth',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 34,
			categoryId: 7,
			questionNo: 11,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmNotOnAnyMedication',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const CharacterAndHabitsUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.CHARACTER_AND_HABITS,
	title: 'characterAndHabits',
	subTitle: 'expectedToBeRoleModel',
	questions: [
		{
			questionId: 9,
			categoryId: 3,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iCommitToUpholdBrotherhoodInMyCenter',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 10,
			categoryId: 3,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iCommitToUpholdMyBehaviour',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 11,
			categoryId: 3,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'noExtremeBehaviourSuchAsAbuseOrAnger',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 12,
			categoryId: 3,
			questionNo: 4,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iReconfirmMaritalHarmonyAndFidelity',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 36,
			categoryId: 3,
			questionNo: 5,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iReconfirmRepurationAndFinancialIntegrity',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'iReconfirmOrNo' },
				{ optionId: 3, optionText: 'iWithdraw' },
			],
			required: true,
			hideComments: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: 152,
			categoryId: 3,
			questionNo: 6,
			questionText: 'pleaseElaborateYourBehaviour',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 228,
				categoryId: 3,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'doYouFindCandidatesConductAcceptable',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
			{
				questionId: 229,
				categoryId: 3,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'haveYouHeardOfAnySpecificSeriousAberrations',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 210,
				categoryId: 3,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'shareThreePositiveQualitiesInYourself',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
			{
				questionId: 211,
				categoryId: 3,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'reconfirmThatNoCharacterOrReputationalIssues',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 236,
				categoryId: 3,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'talkFewWordsAboutApplicant',
				required: true,
				commentsText: 'recordFamilyMemberResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const SupportUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.SUPPORT,
	title: 'familySupport',
	subTitle: 'exploreIfConditionsAroundAreConducive',
	questions: [
		{
			questionId: 19,
			categoryId: 5,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'myFamilyAndIAreComfortableWithSeekersVisitingOurHome',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 20,
			categoryId: 5,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveExplicitlyAskedSupportFromFamily',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 154,
			categoryId: 5,
			questionNo: 3,
			questionText: 'pleaseDescribeYourFamily',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 232,
				categoryId: 5,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'haveYouMetTheCandidatesFamily',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 214,
				categoryId: 5,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'areYourFamilyAlsoPractitioners',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 242,
				categoryId: 5,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'areYourSupportiveOfYourSpouseServing',
				required: true,
				commentsText: 'recordFamilyMemberResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const UnderstandingOfHeartfulnessUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.UNDERSTANDING_OF_HEARTFULNESS,
	title: 'understandingHeartfulness',
	subTitle: 'abilityToExplainHeartfulness',
	questions: [
		{
			questionId: 21,
			categoryId: 6,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iCanExplainBasicPracticesOfHeartfulness',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 22,
			categoryId: 6,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveReadBasicLiteratureOfTheMission',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 37,
			categoryId: 6,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveInterestInReadingTheMissionLiterature',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 155,
			categoryId: 6,
			questionNo: 4,
			questionText: 'whatIsHfnToYou',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 234,
				categoryId: 6,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'doYouBelieveCandidateUnderstandsBasicPrinciples',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 217,
				categoryId: 6,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'haveYouReadSahajMargLiterature',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const DietaryHabitsAndHealthUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.DIETARY_HABITS_AND_HEALTH,
	title: 'dietaryHabitsAndHealth',
	functionaryTitle: 'dietaryHabitsAndHealth',
	subTitle: 'expectedToBeRoleModel',
	questions: [
		{
			questionId: 38,
			categoryId: 8,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iDoNotConsumeAlcohol',
			answerOptions: [
				{ optionId: 1, optionText: 'doNotConsume' },
				{ optionId: 2, optionText: 'consumeOccasionallyAndWillingToGiveUp' },
				{ optionId: 3, optionText: 'cannotGiveUp' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
			hideComments: true,
		},
		{
			questionId: 39,
			categoryId: 8,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iDoNotConsumeNonVegFood',
			answerOptions: [
				{ optionId: 1, optionText: 'doNotConsumeNonVeg' },
				{
					optionId: 2,
					optionText: 'consumeNonVegOccasionallyAndWillingToGiveUp',
				},
				{ optionId: 3, optionText: 'cannotGiveUpNonVeg' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
			hideComments: true,
		},
		{
			questionId: 40,
			categoryId: 8,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmOfReasonablySoundPhysicalHealth',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'no' },
			],
			required: true,
			hideComments: true,
		},
		{
			questionId: 41,
			categoryId: 8,
			questionNo: 4,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'notStudyingHypnotherapy',
			answerOptions: [
				{ optionId: 1, optionText: 'iMNotPracticing' },
				{ optionId: 2, optionText: 'iMPracticing' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
			hideComments: true,
		},
		{
			questionId: MedicationQuestionId.NEW_APPLICATION_ONE,
			categoryId: 8,
			questionNo: 5,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iAmOnMedication',
			answerOptions: [
				{ optionId: 1, optionText: 'yesIMOnMedication' },
				{ optionId: 2, optionText: 'iMNotOnMedication' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
			hideComments: true,
			isCareTeamQuestion: true,
		},
		{
			questionId: MedicationQuestionId.NEW_APPLICATION_TWO,
			categoryId: 8,
			questionNo: 6,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iMNotAddictedToSubstances',
			answerOptions: [
				{ optionId: 1, optionText: 'iMNotAddicted' },
				{ optionId: 2, optionText: 'iMOrWasAddicted' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
			hideComments: true,
			isCareTeamQuestion: true,
		},
		{
			questionId: MedicationQuestionId.NEW_APPLICATION_THREE,
			categoryId: 8,
			questionNo: 7,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iDoNotHaveConditions',
			answerOptions: [
				{ optionId: 1, optionText: 'iHaveTheConditionNow' },
				{ optionId: 2, optionText: 'iHadItInThePast' },
				{ optionId: 3, optionText: 'iDontHaveTheseConditions' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
			hideComments: true,
			isCareTeamQuestion: true,
		},
		{
			questionId: 156,
			categoryId: 8,
			questionNo: 8,
			questionText: 'areThereAnyHealthConditions',
			required: true,
			commentsRequired: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 235,
				categoryId: 7,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'confirmIfCandidateFollowsVegDiet',
				required: true,
				commentsText: 'documentPreceptorResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 219,
				categoryId: 7,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'inCaseYouDoNotMaintainVegDiet',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
			{
				questionId: 220,
				categoryId: 7,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'inCaseYouConsumeAlcohol',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
			{
				questionId: MedicationQuestionId.APPLICANT_INTERVIEW,
				categoryId: 7,
				questionNo: 3,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'confirmYouAreNotOnPsychiatricDrugs',
				answerOptions: [
					{ optionId: 1, optionText: 'notOnPsychiatricMedication' },
					{
						optionId: 2,
						optionText: 'onPsychiatricMedicationAndCanSharePrecription',
					},
					{
						optionId: 3,
						optionText: 'onPsychiatricMedicationAndCantSharePrecription',
					},
				],
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
				isCareTeamQuestion: true,
			},
			{
				questionId: 248,
				categoryId: 7,
				questionNo: 4,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'noLegalDomesticOrFinancialCases',
				required: true,
				commentsText: 'docCandidatesResponse',
				commentsRequired: true,
			},
		],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 246,
				categoryId: 7,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'confirmFamilyMemberMaintainsVegetarianDiet',
				required: true,
				commentsText: 'recordFamilyMemberResponse',
				commentsRequired: true,
			},
			{
				questionId: MedicationQuestionId.FAMILY_MEMBER_INTERVIEW,
				categoryId: 7,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'confirmFamilyIsEmotionallyStable',
				answerOptions: [
					{ optionId: 1, optionText: 'notOnPsychiatricMedication' },
					{
						optionId: 2,
						optionText: 'onPsychiatricMedicationAndCanSharePrecription',
					},
					{
						optionId: 3,
						optionText: 'onPsychiatricMedicationAndCantSharePrecription',
					},
				],
				required: true,
				commentsText: 'recordFamilyMemberResponse',
				commentsRequired: true,
				isCareTeamQuestion: true,
			},
		],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
};

export const PreWorkUIConfig: CategoryStepUIConfig = {
	id: EvaluationCategoryID.PRE_WORK,
	title: '',
	subTitle: '',
	questions: [
		{
			questionId: 51,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 1,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'sadhanaAndSundaySatsangh',
			answerOptions: [
				{ optionId: 1, optionText: '6To7DaysAWeek' },
				{ optionId: 2, optionText: '4To5DaysAWeek' },
				{ optionId: 3, optionText: '1To3DaysAWeek' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: 52,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 2,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveTaken2Sittings',
			answerOptions: [
				{ optionId: 1, optionText: 'yes12To16Sittings' },
				{ optionId: 2, optionText: 'somewhat8To12Sittings' },
				{ optionId: 3, optionText: 'notReallyLessThan8Sittings' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: 53,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 3,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveAttendedSundaySatsanghRegularlyDuringTheseLast8Weeks',
			answerOptions: [
				{ optionId: 1, optionText: '7To8Sundays' },
				{ optionId: 2, optionText: '5To6Sundays' },
				{ optionId: 3, optionText: '3To4Sundays' },
				{ optionId: 4, optionText: '1To2Sundays' },
				{ optionId: 5, optionText: 'none' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: PreWorkQuestionId.HEARTFUL_COMMUNICATION,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 4,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveCompletedHeartfulCommunication',
			answerOptions: [
				{ optionId: 1, optionText: 'completed' },
				{ optionId: 2, optionText: 'startedAndYetToComplete' },
				{ optionId: 3, optionText: 'notStarted' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: 54,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 5,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveCompletedReadingRealityAtDawn',
			answerOptions: [
				{ optionId: 1, optionText: 'completed' },
				{ optionId: 2, optionText: 'partiallyCompleteGreaterThan50Percent' },
				{ optionId: 3, optionText: 'startedRecently' },
				{ optionId: 4, optionText: 'notStarted' },
			],
			required: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: 55,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 6,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iHaveStudiedAndAppliedThePracticeDocument',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'somewhat' },
				{ optionId: 3, optionText: 'notReally' },
			],
			required: true,
		},
		{
			questionId: 57,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 7,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText:
				'iHaveCompletedAtLeasTwoVolunteeringActivityInTheLast8Weeks',
			answerOptions: [
				{ optionId: 1, optionText: 'yes' },
				{ optionId: 2, optionText: 'no' },
			],
			required: true,
		},
		{
			questionId: 58,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 8,
			answerOptionsField: AnswerOptionsField.BUTTONS,
			questionText: 'iDiscussedMyReadinessAndMyCompletionWithMyPreWorkMentor',
			answerOptions: [
				{ optionId: 1, optionText: 'yesAndPreWorkMentorThinksAmReady' },
				{
					optionId: 2,
					optionText: 'yesButPreWorkMentorThinksINeedSomeMoreTime',
				},
				{
					optionId: 3,
					optionText: 'notDiscussed',
				},
			],
			required: true,
			displayAnswerOptionsVertically: true,
		},
		{
			questionId: PreWorkQuestionId.SYSTEM_GENERATED,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 9,
			answerOptionsField: AnswerOptionsField.SELECT,
			questionText: 'systemGeneratedStateOfPreWork',
			answerOptions: [
				{ optionId: 1, optionText: 'complete' },
				{ optionId: 2, optionText: 'partiallyComplete' },
				{ optionId: 3, optionText: 'incomplete' },
			],
			required: true,
			hideComments: true,
			disabled: true,
		},
		{
			questionId: PreWorkQuestionId.CANDIDATE_VIEW_ON_COMPLETION,
			categoryId: EvaluationCategoryID.PRE_WORK,
			questionNo: 10,
			answerOptionsField: AnswerOptionsField.SELECT,
			questionText: 'candidateViewOnCompletionOfPreWork',
			answerOptions: [
				{ optionId: 1, optionText: 'completedPreWork' },
				{ optionId: 2, optionText: 'completedPreWorkBut' },
				{ optionId: 3, optionText: 'partiallyCompletedPreWork' },
			],
			required: true,
		},
	],
	questionsToAskInPreceptorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInApplicantInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInFamilyMemberInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [],
	},
	questionsToAskInOtherReferenceInterview: [],
	questionsToAskInPreworkMentorInterview: {
		suggestedQuestionsToAsk: [],
		mandatoryQuestionsToAsk: [
			{
				questionId: 250,
				categoryId: EvaluationCategoryID.PRE_WORK,
				questionNo: 1,
				answerOptionsField: AnswerOptionsField.BUTTONS,
				questionText: 'applicantHasAttendedSundaySatsangh',
				answerOptions: [
					{ optionId: 1, optionText: 'regular80To100' },
					{ optionId: 2, optionText: 'somewhatRegular50To80' },
					{ optionId: 3, optionText: 'notRegularLessThan50' },
				],
				required: true,
				displayAnswerOptionsVertically: true,
				hideComments: true,
			},
			{
				questionId: 251,
				categoryId: EvaluationCategoryID.PRE_WORK,
				questionNo: 2,
				answerOptionsField: AnswerOptionsField.BUTTONS,
				questionText: 'applicantHasTaken2Sittings',
				answerOptions: [
					{ optionId: 1, optionText: 'yes12To18Sittings' },
					{ optionId: 2, optionText: 'somewhat8To11Sittings' },
					{ optionId: 3, optionText: 'notReallyLessThan8SittingsIn8' },
				],
				required: true,
				displayAnswerOptionsVertically: true,
				hideComments: true,
			},
			{
				questionId: 252,
				categoryId: EvaluationCategoryID.PRE_WORK,
				questionNo: 3,
				answerOptionsField: AnswerOptionsField.BUTTONS,
				questionText: 'pleaseCheckWithCandidateTheirRegularityInPractice',
				answerOptions: [
					{ optionId: 1, optionText: 'yesRegularInAll' },
					{ optionId: 2, optionText: 'somewhat4To5PerWeek' },
					{ optionId: 3, optionText: 'notRegular' },
				],
				required: true,
				displayAnswerOptionsVertically: true,
				hideComments: true,
			},
			{
				questionId: PreWorkQuestionId.MENTOR_CONCERNS_QUESTION,
				categoryId: EvaluationCategoryID.PRE_WORK,
				questionNo: 4,
				answerOptionsField: AnswerOptionsField.BUTTONS,
				questionText: 'anyOtherSeriousConcerns',
				answerOptions: [
					{ optionId: 1, optionText: 'yesIHave' },
					{ optionId: 2, optionText: 'noIDoNotHaveAnyConcerns' },
				],
				required: true,
				displayAnswerOptionsVertically: true,
				hideComments: true,
			},
			{
				questionId: PreWorkQuestionId.MENTOR_SYSTEM_GENERATED,
				categoryId: EvaluationCategoryID.PRE_WORK,
				questionNo: 5,
				answerOptionsField: AnswerOptionsField.SELECT,
				questionText: 'mentorSystemGeneratedStateOfPreWork',
				answerOptions: [
					{ optionId: 1, optionText: 'complete' },
					{ optionId: 2, optionText: 'partiallyComplete' },
					{ optionId: 3, optionText: 'incomplete' },
				],
				required: true,
				hideComments: true,
				disabled: true,
			},
		],
	},
};
